import Swiper, { Navigation, Pagination, Lazy } from "swiper";
Swiper.use([Pagination, Navigation, Lazy]);

const initHowTOGetSlider = () => {
  const slider = document.querySelector(".howtoGet__slider");

  slider &&
    new Swiper(slider, {
      autoHeight: true,
      loop: false,
      lazy: true,
      spaceBetween: 20,
      slidesPerView: 1,
      navigation: {
        nextEl: ".howtoGet-navigation-next",
        prevEl: ".howtoGet-navigation-prev",
        type: "fraction",
      },
      pagination: {
        el: ".howtoGet-navigation__pagination",
        type: "fraction",
      },
    });
};

export default initHowTOGetSlider;
